/**
 * Кнопка HOLD TO SPIN - основное действие игры
 * Использует изображение из public/img/hold-to spin.webp
 */

import * as PIXI from 'pixi.js';
import type { Lang } from '@/utils/storage';

const IMAGE_URL = '/img/hold-to%20spin.webp';
const CENTER_SVG_URL = '/img/button-center.svg';
const BUTTON_SIZE = 240;

const ROTATION_SPEED = 0.001;
const CENTER_ROTATION_SPEED = 0.08; // по часовой стрелке (рад за кадр при delta≈1)
const PULSE_AMPLITUDE = 0.01;
const PULSE_SPEED = 0.05;

export class SpinButton extends PIXI.Container {
  private sprite!: PIXI.Sprite;
  private centerSvg!: PIXI.Sprite;
  private buttonWidth = BUTTON_SIZE;
  private buttonHeight = BUTTON_SIZE;
  private baseScale = 1;
  private pulsePhase = 0;

  constructor() {
    super();
    this.buttonWidth = BUTTON_SIZE;
    this.buttonHeight = BUTTON_SIZE;

    const texture = PIXI.Texture.from(IMAGE_URL);
    this.sprite = new PIXI.Sprite(texture);
    this.sprite.anchor.set(0.5);
    this.sprite.x = BUTTON_SIZE / 2;
    this.sprite.y = BUTTON_SIZE / 2;
    this.baseScale = BUTTON_SIZE / Math.max(texture.width, texture.height, 1);
    this.sprite.scale.set(this.baseScale);
    if (!texture.valid || texture.width === 0) {
      texture.on('update', () => {
        if (texture.width > 0) {
          this.baseScale = BUTTON_SIZE / Math.max(texture.width, texture.height);
        }
      });
    }
    this.addChild(this.sprite);

    const centerTexture = PIXI.Texture.from(CENTER_SVG_URL);
    this.centerSvg = new PIXI.Sprite(centerTexture);
    this.centerSvg.anchor.set(0.5);
    this.centerSvg.x = BUTTON_SIZE / 2 + 3;
    this.centerSvg.y = BUTTON_SIZE / 2 - 3;
    const centerScale = (BUTTON_SIZE / 3) / Math.max(centerTexture.width, centerTexture.height, 1);
    this.centerSvg.scale.set(centerScale);
    if (!centerTexture.valid || centerTexture.width === 0) {
      centerTexture.on('update', () => {
        if (centerTexture.width > 0) {
          const s = (BUTTON_SIZE / 3) / Math.max(centerTexture.width, centerTexture.height);
          this.centerSvg.scale.set(s);
        }
      });
    }
    this.addChild(this.centerSvg);

    this.pivot.set(BUTTON_SIZE / 2, BUTTON_SIZE / 2);
    this.eventMode = 'static';
    this.cursor = 'pointer';
    this.hitArea = new PIXI.Rectangle(0, 0, BUTTON_SIZE, BUTTON_SIZE);

    this.setupHoldInteraction();
  }

  /** Вызывать из game loop для анимации вращения и пульсации */
  update(delta: number): void {
    this.sprite.rotation += delta * ROTATION_SPEED;
    this.pulsePhase += delta * PULSE_SPEED;
    const pulse = 1 + PULSE_AMPLITUDE * Math.sin(this.pulsePhase);
    this.sprite.scale.set(this.baseScale * pulse);
    this.centerSvg.alpha = (1 + Math.sin(this.pulsePhase)) / 2;
    this.centerSvg.rotation += delta * CENTER_ROTATION_SPEED;
  }

  private setupHoldInteraction(): void {}

  setEnabled(enabled: boolean): void {
    this.eventMode = enabled ? 'static' : 'auto';
    this.cursor = enabled ? 'pointer' : 'default';
    this.alpha = enabled ? 1 : 0.5;
  }

  setText(_text: string): void {}

  setLang(_lang: Lang): void {}

  get width(): number {
    return this.buttonWidth;
  }

  get height(): number {
    return this.buttonHeight;
  }
}
